/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateHexFromHomeMutationVariables = Types.Exact<{
  name: Types.Scalars["String"]["input"];
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  dataConnectionIds: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["DataConnectionId"]["input"]>
    | Types.Scalars["DataConnectionId"]["input"]
  >;
  cellsToCreate: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CellContentsPayload"]["input"]>
    | Types.Scalars["CellContentsPayload"]["input"]
  >;
}>;

export type CreateHexFromHomeMutation = {
  readonly __typename: "Mutation";
  readonly createHex: { readonly __typename: "Hex"; readonly id: c.HexId };
};

export type GetTableColumnsForMetricViewQueryVariables = Types.Exact<{
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
}>;

export type GetTableColumnsForMetricViewQuery = {
  readonly __typename: "Query";
  readonly dataSourceTableById: {
    readonly __typename: "DataSourceTable";
    readonly id: c.DataSourceTableId;
    readonly columns: ReadonlyArray<{
      readonly __typename: "DataSourceColumn";
      readonly id: c.DataSourceColumnId;
      readonly name: string;
      readonly columnSemanticLayerType: Types.ColumnSemanticLayerType | null;
    }>;
  };
};

export const CreateHexFromHomeDocument = /*#__PURE__*/ gql`
  mutation CreateHexFromHome(
    $name: String!
    $description: String
    $dataConnectionIds: [DataConnectionId!]
    $cellsToCreate: [CellContentsPayload!]
  ) {
    createHex(
      name: $name
      description: $description
      dataConnectionIds: $dataConnectionIds
      cellsToCreate: $cellsToCreate
    ) {
      id
    }
  }
`;
export type CreateHexFromHomeMutationFn = Apollo.MutationFunction<
  CreateHexFromHomeMutation,
  CreateHexFromHomeMutationVariables
>;

/**
 * __useCreateHexFromHomeMutation__
 *
 * To run a mutation, you first call `useCreateHexFromHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHexFromHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHexFromHomeMutation, { data, loading, error }] = useCreateHexFromHomeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      dataConnectionIds: // value for 'dataConnectionIds'
 *      cellsToCreate: // value for 'cellsToCreate'
 *   },
 * });
 */
export function useCreateHexFromHomeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateHexFromHomeMutation,
    CreateHexFromHomeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateHexFromHomeMutation,
    CreateHexFromHomeMutationVariables
  >(CreateHexFromHomeDocument, options);
}
export type CreateHexFromHomeMutationHookResult = ReturnType<
  typeof useCreateHexFromHomeMutation
>;
export type CreateHexFromHomeMutationResult =
  Apollo.MutationResult<CreateHexFromHomeMutation>;
export type CreateHexFromHomeMutationOptions = Apollo.BaseMutationOptions<
  CreateHexFromHomeMutation,
  CreateHexFromHomeMutationVariables
>;
export const GetTableColumnsForMetricViewDocument = /*#__PURE__*/ gql`
  query GetTableColumnsForMetricView($dataSourceTableId: DataSourceTableId!) {
    dataSourceTableById(dataSourceTableId: $dataSourceTableId) {
      id
      columns {
        id
        name
        columnSemanticLayerType
      }
    }
  }
`;

/**
 * __useGetTableColumnsForMetricViewQuery__
 *
 * To run a query within a React component, call `useGetTableColumnsForMetricViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTableColumnsForMetricViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTableColumnsForMetricViewQuery({
 *   variables: {
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *   },
 * });
 */
export function useGetTableColumnsForMetricViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  > &
    (
      | {
          variables: GetTableColumnsForMetricViewQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  >(GetTableColumnsForMetricViewDocument, options);
}
export function useGetTableColumnsForMetricViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  >(GetTableColumnsForMetricViewDocument, options);
}
export function useGetTableColumnsForMetricViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTableColumnsForMetricViewQuery,
    GetTableColumnsForMetricViewQueryVariables
  >(GetTableColumnsForMetricViewDocument, options);
}
export type GetTableColumnsForMetricViewQueryHookResult = ReturnType<
  typeof useGetTableColumnsForMetricViewQuery
>;
export type GetTableColumnsForMetricViewLazyQueryHookResult = ReturnType<
  typeof useGetTableColumnsForMetricViewLazyQuery
>;
export type GetTableColumnsForMetricViewSuspenseQueryHookResult = ReturnType<
  typeof useGetTableColumnsForMetricViewSuspenseQuery
>;
export type GetTableColumnsForMetricViewQueryResult = Apollo.QueryResult<
  GetTableColumnsForMetricViewQuery,
  GetTableColumnsForMetricViewQueryVariables
>;
